import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import SocialIcons from './SocialIcons';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#000',
    padding: '44px 0 60px 0',
    color: '#e3e9ec'
  },
  title: {
    paddingTop: theme.spacing(2),
  },
  subtitle: {
    paddingTop: theme.spacing(1) / 2,
  },
  hashTag: {
    paddingTop: theme.spacing(2),
  },
  link: {
    paddingBottom: theme.spacing(3),
  },
  corrivium: {
    paddingTop: theme.spacing(3),
  },
  rights: {
    paddingTop: theme.spacing(1) /2,
  },
  privacy: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  href: {
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
      color: '#fff',
      textDecoration: 'underline'
    }
  }
}));

export default () => {
  const classes = useStyles();
  return (
    <div className="footer">
      <div className={classes.root}>
      <Container>
        <Grid container direction="row" justify="space-between">
          <Grid item>
            <div className={classes.title}><h4><a href="https://www.engineersaustralia.org.au" target="_blank" rel="noopener noreferrer" className={classes.href}>Pinnacles Awards 2020</a></h4></div>
            <div className={classes.subtitle}><h5 style={{fontWeight: 400}}>People &amp; Projects</h5></div>
            <div  className={classes.hashTag}><h5><a href="https://twitter.com/search?q=PinnaclesAwards2020" target="_blank" rel="noopener noreferrer" className={classes.href}>#PinnaclesAwards2020</a></h5></div>
            <div className={classes.link}><h5><a href="https://www.engineersaustralia.org.au" target="_blank" rel="noopener noreferrer" className={classes.href}>www.engineersaustralia.org.au</a></h5></div>
            <SocialIcons />
          </Grid>
          <Grid item>
            <div  className={classes.corrivium}><h4>&copy; Copyright 2020 | <a href="https://www.corrivium.com" target="_blank" rel="noopener noreferrer" className={classes.href}>Corrivium Live</a></h4></div>
            <div  className={classes.rights}><h5 style={{fontWeight: 400}}>All Rights Reserved</h5></div>
            <div className={classes.privacy}><h5><a href="https://www.corrivium.com/privacy" target="_blank" rel="noopener noreferrer" className={classes.href}>Privacy Policy</a></h5></div>
          </Grid>
        </Grid>
      </Container>
      </div>
    </div>
  );
}


